module.exports = __webpack_public_path__ + "img/express_document.ea6f906f.png";